import React from 'react';

// Login ve Ana Sayfa arasında paylaşılan marka bileşeni — /logo.png yüklenemezse ◈ glifine düşer
// (bkz. eskiden Login.jsx içinde inline duran aynı fallback deseni).
export default function BrandLogo({ className = '', imgClassName = '', fallbackClassName = '' }) {
  return (
    <div className={`brand-logo ${className}`}>
      <img
        src="/logo.png"
        alt="TrendSniper"
        className={`brand-logo-img ${imgClassName}`}
        onError={e => { e.target.style.display = 'none'; e.target.nextSibling.style.display = 'flex'; }}
      />
      <div className={`brand-logo-fallback ${fallbackClassName}`} style={{ display: 'none' }}>
        <span className="brand-logo-icon">◈</span>
      </div>
    </div>
  );
}
